import { createApp } from 'vue'
import App from './App.vue'
import { createPinia } from 'pinia'
import './registerServiceWorker'

const pinia = createPinia()
window.isPlay = false;
createApp(App).use(pinia).mount('#app')
